import { ParentProps } from 'solid-js';

export const CarouselItem = (props: ParentProps) => <li class="splide__slide">{props.children}</li>;
